import { Component, OnInit,Input } from '@angular/core';

@Component({
    selector: 'app-product-ghost',
    template: `<div class="row" *ngIf="ghosts.length > 0">
            <div class="ghostbanner"></div>
            <div class="container">
                <div class="row">
                    <div *ngFor='let it of ghosts' class='col-lg-4 col-md-4 col-sm-4 col-xs-12'>
                        <div class="ghost_item">
                            <div class="avatar"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div><div class="container" *ngIf="CertificateGhosts.length > 0">
            <div class="row">
                <div *ngFor='let it of CertificateGhosts' class='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                    <div class="ghost_item">
                        <div class="certificate_avatar"></div>
                    </div>
                </div>
            </div>
        </div><div class="container" *ngIf="TradeFair.length > 0">
            <div class="row" *ngFor='let t of TradeFair'>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="event_name_desc"></div>
                </div>
                <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                    <div class="event_photoes"></div>
                </div>
            </div>
        </div>`,
    styleUrls: ['./product-ghost.component.scss']
})

export class ProductGhostComponent {

    @Input() ghosts : any[];
    @Input() CertificateGhosts : any[];
    @Input() TradeFair : any[];
}
